"use strict";

var _interopRequireDefault = require("D:/work/code/aihuz/arbitration-ui/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("D:/work/code/aihuz/arbitration-ui/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/work/code/aihuz/arbitration-ui/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _rtcDetect = _interopRequireDefault(require("rtc-detect"));
//
//
//
//
//
//
var _default = {
  components: {},
  data: function data() {
    return {
      result: ""
    };
  },
  methods: {
    test: function () {
      var _test = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var detect, result;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              detect = new _rtcDetect.default(); // 获得当前环境监测结果
              _context.next = 3;
              return detect.getReportAsync();
            case 3:
              result = _context.sent;
              // result 包含了当前环境系统的信息，API 支持度，编解码支持度，设备相关的信息
              console.log("result is: ", result);
              this.result = JSON.stringify(result);
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function test() {
        return _test.apply(this, arguments);
      }
      return test;
    }()
  },
  mounted: function mounted() {
    // clearUrlParam();
    // 初始化监测模块
    this.test();
  }
};
exports.default = _default;